const { BASE_URL } = require("./client");

const POST_CAREER = BASE_URL + "/api/email/Career";
const POST_CONTACT = BASE_URL + "/api/email/contactus";

module.exports = {
  POST_CAREER,
  POST_CONTACT,
};
